import { ChartBarIcon, PresentationChartLineIcon, Squares2X2Icon, TableCellsIcon } from '@heroicons/react/20/solid';

export type TrendChartView = 'dual-axis' | 'line' | 'stacked-area' | 'table';

interface TrendChartViewToggleProps {
  activeView: TrendChartView;
  onViewChange: (view: TrendChartView) => void;
}

export default function TrendChartViewToggle({ activeView, onViewChange }: TrendChartViewToggleProps) {
  const views: { id: TrendChartView; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
    { id: 'dual-axis', label: 'Dual-Axis', icon: ChartBarIcon },
    { id: 'line', label: 'Line', icon: PresentationChartLineIcon },
    { id: 'stacked-area', label: 'Stacked', icon: Squares2X2Icon },
    { id: 'table', label: 'Table', icon: TableCellsIcon },
  ];

  return (
    <div className="absolute top-4 right-4 flex gap-1 bg-gray-100 rounded-lg p-1">
      {views.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onViewChange(id)}
          className={`
            flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
            ${activeView === id
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
            }
          `}
          title={label}
        >
          <Icon className="w-4 h-4" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      ))}
    </div>
  );
}
